export var BASE_URL = 'https://tagmanager.sportnet.online/api/v3';
